import { Box, Typography } from '@mui/material'
import GoogleIcon from '../icon/GoogleIcon'

/**
 * Cómo reutilizar este componente:
 *
 * <ClientHeaderCard
 *   icon="event"
 *   label="Fecha de creación:"
 *   value={formattedDate}
 *   filled={false}
 *   iconColor={UI_COLOR_TEXT_ICON}
 * />
 *
 * Props:
 * - icon: nombre del GoogleIcon que se va a mostrar.
 * - label: texto fijo del dato, por ejemplo "Código:".
 * - value: valor que se pinta junto al label.
 * - filled: activa la variante rellena del icono cuando aplique.
 * - iconColor: color personalizado del icono (p. ej. UI_COLOR_TEXT_ICON).
 */
export default function ClientHeaderCard({
  icon,
  label,
  value,
  filled = false,
  iconColor,
  sx = {},
  iconSx = {},
  iconSize = 20,
  labelSx = {},
  valueSx = {}
}) {
  return (
    <Box className="client-header-card" sx={sx}>
      <Box className="client-header-card-icon" sx={iconSx}>
        <GoogleIcon
          name={icon}
          size={iconSize}
          color={iconColor}
          filled={filled}
          className="client-header-card-google-icon"
        />
      </Box>

      <Typography className="client-header-card-label" sx={labelSx}>
        {label}
      </Typography>

      <Typography className="client-header-card-value" sx={valueSx}>
        {value}
      </Typography>
    </Box>
  )
}
